import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import p1 from "../../Assets/images/p1.png";

const ImagePreview = ({ showModal, selectedImage, onClose, title }) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    setImage(selectedImage);
  }, [selectedImage]);
  useEffect(() => {
    console.log("Title received:", title);
  }, [title, showModal]); 

  return (
    <>
      <Modal show={showModal} onHide={onClose} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>{title || "Image Preview"}</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="text-center">
          {image ? (
            <img
              src={image}
              // alt="Image Preview"
              className="img-fluid"
              style={{ maxHeight: "500px" }}
            />
          ) : (
            <p>
              <img
                src={p1}
                // alt="Image Preview"
                className="img-fluid"
                style={{ maxHeight: "500px" }}
              />
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImagePreview;
